import Vue from 'vue'
import {
  Button,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  Stepper,
  Field,
  Popup,
  Picker,
  ActionSheet,
  AddressList,
  Toast,
  Dialog,
  Row,
  Col,
  NavBar,
  Icon,
  Form,
  Image,
  CellGroup,
  Cell,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tag,
  Checkbox,
  ImagePreview
} from 'vant'
Vue.use(Button).use(Tabbar).use(TabbarItem).use(Swipe).use(SwipeItem).use(Tabs).use(Tab).use(Stepper).use(Field).use(Popup).use(Picker).use(ActionSheet).use(AddressList).use(Dialog).use(Row).use(Col).use(NavBar).use(Icon).use(Form).use(Image).use(CellGroup).use(Cell).use(DatetimePicker).use(Radio).use(RadioGroup).use(Tag).use(Checkbox).use(ImagePreview)
Vue.prototype.$toast = Toast